import { PodcastEvent } from "../constants";
import { PodcastSeason } from "./PodcastSeason";
import { PodcastEpisode } from "./PodcastEpisode";
import { PodcastLazyLoader } from "./PodcastsLazyLoader";

declare global {
    interface Window {
        PodcastsData?: IPodcastsConfigFront;
    }
}

export class PodcastsFront {

    private seasons: PodcastSeason[] = [];

    constructor() {
        if (window.PodcastsData) {
            this.init();
        }
    }

    init() {
        if (this.useSeasons) {
            const seasonElements = Array.from(document.querySelectorAll('.cwf-podcast-season'));
            this.seasons = seasonElements.map((element: HTMLElement) => new PodcastSeason({ element }));
            this.seasons.forEach((season: PodcastSeason) => season.addListener(PodcastEvent.SELECT_SEASON, this.onSelectSeason.bind(this)));
        } else {
            // Observe all ".cwf-podcast-episode" elements
            // When they intersect, set the audio src to data-src

            const observer: IntersectionObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const audio = entry.target.querySelector('audio') as HTMLAudioElement;
                            if (!audio.src) {
                                const audioSrc = audio.dataset.src;
                                audio.src = audioSrc;
                            }
                        }
                    });
                }
            );

            const episodeElements = Array.from(document.querySelectorAll('.cwf-podcast-episode'));

            episodeElements.forEach((el: HTMLElement) => {
                observer.observe(el);
            });
        }

        const hasLoadBoundary = document.querySelector('.load-boundary');
        if (hasLoadBoundary) {
            new PodcastLazyLoader();
        }
    }

    onSelectSeason(season?: PodcastSeason): void {
        // Close up all other seasons
        const otherSeasons = this.seasons.filter((s: PodcastSeason) => s !== season);
        otherSeasons.forEach((s: PodcastSeason) => s.close());
    }

    get useSeasons() {
        return window.PodcastsData.useSeasons;
    }
}